import Head from 'components/Head';
import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/router';

export default function ItemWrapper() {
  const router = useRouter();

  useEffect(() => {
    router.push('/');
  });

  return (
    <div>
      <Head />

      <main>

      </main>
    </div>
  )
}